// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_ADD_NOTIFICATION,
} from './constants';

export function addNotification(data) {
  return {
    type: COMMON_ADD_NOTIFICATION,
    data
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_ADD_NOTIFICATION:
      return {
        ...state,
        pager: state.pager.withMutations(pager => {
          let isExist = pager.find(p => p.id === action.data.id)
          return !isExist ? pager.unshift(action.data) : pager
        })
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/addNotification.js